package com.eladfinish.bible.contest.di.audio

import com.eladfinish.bible.contest.platform.audio.SoundService
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal val audioCommonModule = module {
    includes(audioPlatformModule)
    singleOf(::SoundService)
}
